<div id="messagesTopFreightFormComponent">
  <lib-message-ui-ionic [messages]="messages"></lib-message-ui-ionic>
</div>

<lib-freight-shipper-edit-general-form
  [freight]="freight()"
  (dataModified)="onGeneralFormUpdated($event)"
  #generalForm
></lib-freight-shipper-edit-general-form>
@for (stop of stops(); track stop.id) {
  <div
    [id]="stop.id"
    [ngClass]="{ 'stop-form-hidden': hiddenStops || hiddenStopId === stop.id }"
    class="stop-form"
  >
    <lib-freight-shipper-edit-stop-form
      [stopData]="{ stop: stop, totalNumberStops: stops().length }"
      (removeStop)="onRemoveStop($event)"
      (moveStopUp)="onReorderStop($event)"
      (moveStopDown)="onReorderStop($event)"
      (dataModified)="onStopFormUpdated($event)"
      #stopForm
    ></lib-freight-shipper-edit-stop-form>
  </div>
}

<p class="ion-text-center">
  Total de paradas:
  <strong>{{ stops().length }}</strong>
</p>
